import React, { createContext, useContext, useMemo } from 'react';

const ThemeContext = createContext();

const theme = {
  bg: '#f0f2f5',
  surface: '#ffffff',
  surfaceAlt: '#f5f6f8',
  text: '#1a1a2e',
  textSecondary: '#5f6368',
  border: '#e0e0e0',
  primary: '#1a73e8',
  primaryHover: '#1557b0',
  danger: '#ea4335',
  dangerHover: '#d33426',
  success: '#34a853',
  controlBg: '#e8eaed',
  controlHover: '#d2d4d8',
  inputBg: '#ffffff',
  scrollbar: '#c4c7cc',
  shadow: 'rgba(0,0,0,0.08)',
};

export function ThemeProvider({ children }) {
  const value = useMemo(() => ({ theme }), []);

  return (
    <ThemeContext.Provider value={value}>
      <div style={{ ...globalStyles, backgroundColor: theme.bg, color: theme.text, minHeight: '100vh' }}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}

const globalStyles = {
  margin: 0,
  padding: 0,
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, sans-serif',
  transition: 'background-color 0.3s, color 0.3s',
};
